import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { AttachmentFileType } from 'owa-attachment-file-types';
import { AttachmentState } from 'owa-attachment-full-data';
import DeleteAttachmentResponseMessage from 'owa-service/lib/contract/DeleteAttachmentResponseMessage';
import ItemId from 'owa-service/lib/contract/ItemId';
import { trace } from 'owa-trace';
import datapoints from '../datapoints';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import deleteAttachmentService from '../services/deleteAttachment';
import removeAttachmentFromWell from './removeAttachmentFromWell';
import updateChangeKeyOnItemId from './updateChangeKeyOnItemId';

export default createLegacyActionWithDatapoint(
    'deleteAttachment',
    datapoints.AttachmentDeletionAction
)(function deleteAttachment(
    attachmentWellViewState: AttachmentWellViewState,
    attachmentState: AttachmentState,
    parentItemId: ItemId,
    attachmentFileType: AttachmentFileType /* this parameter is used in datapoint logging */
): Promise<void> {
    return deleteAttachmentService(attachmentState.attachmentId)
        .then(response => {
            const responseMessage: DeleteAttachmentResponseMessage =
                response.ResponseMessages.Items[0];
            if (responseMessage.ResponseClass === 'Success') {
                removeAttachmentFromWell(attachmentWellViewState, attachmentState);
                updateChangeKeyOnItemId(parentItemId, responseMessage.RootItemId.RootItemChangeKey);
            } else {
                trace.warn(
                    `Attachment: Failed to delete attachment with ResponseClass= ${
                        responseMessage.ResponseClass
                    }, ResponseCode=${responseMessage.ResponseCode}`
                );
            }
        })
        .catch(error => {
            trace.warn('Attachment: deleteAttachment got error: ' + error.message);

            // Rethrow the error so that it is returned as catch for the promise returned from this function
            throw error;
        });
});
